import React, { useState } from 'react';
import { useChatContext } from 'stream-chat-react';

import { UserList } from './';
import { CloseCreateChannel } from '../assets';

const ChannelNameInput = ({ channelName = '', setChannelName }) => {
    const handleChange = (event) => {
        event.preventDefault();
        setChannelName(event.target.value);
    }

    return (
        <div className="channel-name-input__wrapper">
            <p>Name</p>
            <input value={channelName} onChange={handleChange} placeholder="channel-name" />
            <p>Add Members</p>
        </div>
    )
}

const CreateChannel = ({ createType, setIsCreating }) => {
  const { client, setActiveChannel } = useChatContext(); //for extracting our own id for populating ourselves in the group
  const [selectedUsers, setSelectedUsers] = useState([client.userID || '']); //client.userID - we're just populating ourselves as a member of the group
  //selectedUsers state is to keep track of all the (toggled on - for inviting )selected users
  const [channelName, setChannelName] = useState('');

    const createChannel = async (e) => {
        e.preventDefault();

        try {
            const newChannel = await client.channel(createType, channelName, {
                name: channelName, members: selectedUsers
            }); //we got client.channel out of the box from streamchat

            newChannel.watch(); //watch for new messages in the channel 

            setChannelName('');
            setIsCreating(false); //so that noone else is still creating it
            setSelectedUsers([client.userID]); //adding ourself in the group
            setActiveChannel(newChannel); //opening the created channel automatically as soon as it's created
        } catch (error) {
            console.log(error);
        }
    }

      return (
        <div className="create-channel__container">
            <div className="create-channel__header">
                <p>{createType === 'team' ? 'Create a New Channel' : 'Send a Direct Message'}</p>
                <CloseCreateChannel setIsCreating={setIsCreating} /> {/* This will just diable us from creating/editing that channel as of then */ }
            </div>
            {createType === 'team' && <ChannelNameInput channelName={channelName} setChannelName={setChannelName}/>}
            <UserList setSelectedUsers={setSelectedUsers}/>
            <div className="create-channel__button-wrapper" onClick={createChannel}>
                <p>{createType === 'team' ? 'Create Channel' : 'Create Message Group'}</p> 
                {/* This p tag is a button, If we click on + of channel, then Create channel button will appear. 
                If clicked on + of direct messages, Create message group button will appear */}
            </div>
        </div>
      )
}

export default CreateChannel